import React from "react";
import { Skeleton } from "primereact/skeleton";
const ViewStoreProductLoading = () => {
    return (
        <div>
            <div className="flex mx-5">
                <Skeleton className="breadcrumb-skeleton" />
                <Skeleton className="breadcrumb-skeleton" />
                <Skeleton className="breadcrumb-skeleton" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
                <div>
                    <div className="m-5">
                        <Skeleton className="prod-skeleton" />
                    </div>
                    <div className="flex flex-wrap mx-5">
                        <Skeleton className="small-prod-skeleton mx-2" />
                        <Skeleton className="small-prod-skeleton mx-2" />
                        <Skeleton className="small-prod-skeleton mx-2 hidden md:block lg:block" />
                        <Skeleton className="small-prod-skeleton mx-2 hidden lg:block" />

                    </div>
                </div>
                <div>
                    <div className="m-5">
                        <Skeleton className="prod-details-name" />
                        <div className="mx-4">
                            <Skeleton className="prod-details-desc" />
                        </div>
                        <Skeleton className="prod-details-price" />
                        <Skeleton className="prod-details-vars" />
                        <div className="flex">
                            <Skeleton className="prod-details-qun" />
                            <Skeleton className="prod-details-cart-btn" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewStoreProductLoading;